import ScrollLink from '../globals/scroll-link';

export default class Glossary {
  constructor() {
    new ScrollLink({
      duration: 500
    });
  }
}
